import RequestOrgRegist from "@/views/login/RequestOrgRegist.vue";

export const USER_ROUTES = {
  Root: {
    Path: "/",
    Name: "Root",
  },
  Home: {
    Path: "/Home",
    Name: "Home",
  },
  Intro: {
    Path: "/Intro",
    Name: "Intro",
  },
  Instruction: {
    individual: {
      Path: "/instruction/individual",
      Name: "instructionIndividual",
    },
    org: {
      Path: "/instruction/org",
      Name: "instructionOrg",
    },
  },
  Coaching: {
    Putt: {
      Path: "/Product/Coaching/Putt",
      Name: "CoachingPutt",
      Putt_e: {
        Path: "/Product/Coaching/Putt_e",
        Name: "CoachingPutt_e",
      },
      Putt_m: {
        Path: "/Product/Coaching/Putt_m",
        Name: "CoachingPutt_m",
      },
      Putt_h: {
        Path: "/Product/Coaching/Putt_h",
        Name: "CoachingPutt_h",
      },
      Putt_u: {
        Path: "/Product/Coaching/Putt_u",
        Name: "CoachingPutt_u",
      },
    },
    Tocc: {
      Path: "/Product/Coaching/Tocc",
      Name: "CoachingTocc",
      Tocc_e: {
        Path: "/Product/Coaching/Tocc_e",
        Name: "CoachingTocc_e",
      },
      Tocc_m: {
        Path: "/Product/Coaching/Tocc_m",
        Name: "CoachingTocc_m",
      },
      Tocc_h: {
        Path: "/Product/Coaching/Tocc_h",
        Name: "CoachingTocc_h",
      },
      Tec: {
        Path: "/Product/Coaching/Tec",
        Name: "CoachingTec",
      },
    },
  },
  Product: {
    Testing: {
      Putt: {
        Path: "/Product/Testing/Putt",
        Name: "TestingPutt",
        Putt_e: {
          Path: "/Product/Testing/Putt_e",
          Name: "TestingPutt_e",
        },
        Putt_m: {
          Path: "/Product/Testing/Putt_m",
          Name: "TestingPutt_m",
        },
        Putt_h: {
          Path: "/Product/Testing/Putt_h",
          Name: "TestingPutt_h",
        },
        Putt_u: {
          Path: "/Product/Testing/Putt_u",
          Name: "TestingPutt_u",
        },
      },
      Tocc: {
        Path: "/Product/Testing/Tocc",
        Name: "TestingTocc",
        Tocc_e: {
          Path: "/Product/Testing/Tocc_e",
          Name: "TestingTocc_e",
        },
        Tocc_h: {
          Path: "/Product/Testing/Tocc_h",
          Name: "TestingTocc_h",
        },
        Tec: {
          Path: "/Product/Testing/Tec",
          Name: "TestingTec",
        },
      },
      Kat: {
        Path: "/Product/Testing/Kat",
        Name: "TestingKat",
      },
    },
    Coaching: {
      Putt: {
        Path: "/Product/Coaching/Putt",
        Name: "CoachingPutt",
        Putt_e: {
          Path: "/Product/Coaching/Putt_e",
          Name: "CoachingPutt_e",
        },
        Putt_m: {
          Path: "/Product/Coaching/Putt_m",
          Name: "CoachingPutt_m",
        },
        Putt_h: {
          Path: "/Product/Coaching/Putt_h",
          Name: "CoachingPutt_h",
        },
        Putt_u: {
          Path: "/Product/Coaching/Putt_u",
          Name: "CoachingPutt_u",
        },
      },
      Tocc: {
        Path: "/Product/Coaching/Tocc",
        Name: "CoachingTocc",
        Tocc_e: {
          Path: "/Product/Coaching/Tocc_e",
          Name: "CoachingTocc_e",
        },
        Tocc_m: {
          Path: "/Product/Coaching/Tocc_m",
          Name: "CoachingTocc_m",
        },
        Tocc_h: {
          Path: "/Product/Coaching/Tocc_h",
          Name: "CoachingTocc_h",
        },
        Tec: {
          Path: "/Product/Coaching/Tec",
          Name: "CoachingTec",
        },
      },
    },
    Activity: {
      Talent: {
        Path: "/Product/Activity/Talent",
        Name: "ActivityTalent",
        Talent_e: {
          Path: "/Product/Activity/Talent_e",
          Name: "ActivityTalent_e",
        },
        Talent_m: {
          Path: "/Product/Activity/Talent_m",
          Name: "ActivityTalent_m",
        },
        Talent_h: {
          Path: "/Product/Activity/Talent_h",
          Name: "ActivityTalent_h",
        },
        Talent_u: {
          Path: "/Product/Activity/Talent_u",
          Name: "ActivityTalent_u",
        },
      },
      Startup: {
        Path: "/Product/Activity/Startup",
        Name: "ActivityStartup",
        Startup_e: {
          Path: "/Product/Activity/Startup_e",
          Name: "ActivityStartup_e",
        },
        Startup_m: {
          Path: "/Product/Activity/Startup_m",
          Name: "ActivityStartup_m",
        },
        Startup_h: {
          Path: "/Product/Activity/Startup_h",
          Name: "ActivityStartup_h",
        },
      },
      Career: {
        Path: "/Product/Activity/Career",
        Name: "ActivityCareer",
        Career_e: {
          Path: "/Product/Activity/Career_e",
          Name: "ActivityCareer_e",
        },
        Career_m: {
          Path: "/Product/Activity/Career_m",
          Name: "ActivityCareer_m",
        },
        Career_h: {
          Path: "/Product/Activity/Career_h",
          Name: "ActivityCareer_h",
        },
        Career_u: {
          Path: "/Product/Activity/Career_u",
          Name: "ActivityCareer_u",
        },
      },
      Growth: {
        Path: "/Product/Activity/Growth",
        Name: "ActivityGrowth",
        Growth_e: {
          Path: "/Product/Activity/Growth_e",
          Name: "ActivityGrowth_e",
        },
        Growth_m: {
          Path: "/Product/Activity/Growth_m",
          Name: "ActivityGrowth_m",
        },
        Growth_h: {
          Path: "/Product/Activity/Growthp_h",
          Name: "ActivityGrowth_h",
        },
      },
    },
    Expert: {
      Expert: {
        Path: "/Product/Expert/Expert",
        Name: "ActivityExpert",
        Expert_e: {
          Path: "/Product/Expert/Expert_e",
          Name: "ActivityExpert_e",
        },
        Expert_h: {
          Path: "/Product/Expert/Expert_h",
          Name: "ActivityExpert_h",
        },
        Expert_b: {
          Path: "/Product/Expert/Expert_b",
          Name: "ActivityExpert_b",
        },
        Expert_p: {
          Path: "/Product/Expert/Expert_p",
          Name: "ActivityExpert_p",
        },
      },
      Cert: {
        Path: "/Product/Cert",
        Name: "ActivityCert",
      },
    },
  },
  Price: {
    Org: {
      Path: "/Org",
      Name: "PriceOrg",
      Test: {
        Path: "/Org/Test",
        Name: "PriceTest",
      },
      Activity: {
        Path: "/Org/Activity",
        Name: "PriceActivity",
      },
      Expert: {
        Path: "/Org/Expert",
        Name: "PriceExpert",
      },
    },
    Personal: {
      Path: "/Personal",
      Name: "PricePersonal",
      Test: {
        Path: "/Personal/Test",
        Name: "PriceTest",
      },
      Activity: {
        Path: "/Personal/Activity",
        Name: "PriceActivity",
      },
      Expert: {
        Path: "/Personal/Expert",
        Name: "PriceExpert",
      },
    },
  },
  Offer: {
    Personal: {
      Path: "/Offer/Personal/:product_key",
      Name: "Personal",
    },
  },
  Qna: {
    Path: "/Qna",
    Name: "Qna",
    Content: {
      Path: "/Qna/Content/:id",
      Name: "QnaContent",
    },
  },
  Notice: {
    Path: "/Notice",
    Name: "Notice",
    Content: {
      Path: "/Notice/Content/:id",
      Name: "NoticeContent",
    },
  },
  Press: {
    Path: "/Press",
    Name: "Press",
    Content: {
      Path: "/Press/Content/:id",
      Name: "PressContent",
    },
  },
  Inquiry: {
    Path: "/Inquiry",
    Name: "Inquiry",
  },
  OrgInquiry: {
    Path: "/OrgInquiry/:pid",
    Name: "OrgInquiry",
  },
  About: {
    Path: "/About",
    Name: "About",
    Profile: {
      Path: "/About/Profile",
      Name: "Profile",
    },
    Philosophy: {
      Path: "/About/Philosophy",
      Name: "Philosophy",
    },
    Vision: {
      Path: "/About/Vision",
      Name: "Vision",
    },
    OrgChart: {
      Path: "/About/OrgChart",
      Name: "OrgChart",
    },
    Map: {
      Path: "/About/Map",
      Name: "Map",
    },
  },
  Privacy: {
    Path: "/Privacy",
    Name: "Privacy",
  },
  Login: {
    Path: "/Login",
    Name: "Login",
  },
  Join: {
    Path: "/Join",
    Name: "Join",
    Registration: {
      Path: "/Join/Registration",
      Name: "JoinRegistration",
    },
    Success: {
      Path: "/Join/Success/:id",
      Name: "JoinSuccess",
    },
  },
  RequestOrgRegist: {
    Path: "/RequestOrgRegist",
    Name: "RequestOrgRegist",
  },
  Mypage: {
    Path: "/Mypage",
    Name: "Mypage",
    Modify: {
      Path: "/Mypage/Modify",
      Name: "MypageModify",
    },
    Delete: {
      Path: "/Mypage/Delete",
      Name: "MypageDelete",
    },
    User: {
      Org: {
        Path: "/Mypage/User/Org",
        Name: "MypageUserOrg",
        Register: {
          Path: "/Mypage/User/Org/Register",
          Name: "MypageUserOrgRegister",
        },
        Detail: {
          Path: "/Mypage/User/Org/Detail/:SK",
          Name: "MypageUserOrgDetail",
        },
      },
    },
    Order: {
      Personal: {
        Path: "/Mypage/Order/Personal",
        Name: "MypageOrderPersonal",
        Detail: {
          Path: "/Mypage/Order/Personal/Detail/:SK",
          Name: "MypageOrderPersonalDetailProject",
        },
      },
      Org: {
        Path: "/Mypage/Order/Org",
        Name: "MypageOrderOrg",
        Request: {
          Path: "/Mypage/Order/Org/Request/:pid",
          Name: "MypageOrderOrgRequest",
        },
        RequestList: {
          Path: "/Mypage/Order/Org/RequestList",
          Name: "MypageOrderOrgRequestList",
        },
        PurchaseList: {
          Path: "/Mypage/Order/Org/PurchaseList",
          Name: "MypageOrderOrgPurchaseList",
        },
        Detail: {
          Path: "/Mypage/Order/Org/Detail/:SK",
          Name: "MypageOrderOrgDetail",
        },
        Project: {
          Path: "/Mypage/Order/Org/Project/:SK",
          Name: "MypageOrderOrgProject",
          Detail: {
            Path: "/Mypage/Order/Org/Project/Detail/:SK",
            Name: "MypageOrderOrgProjectDetail",
          },
        },
      },
    },
  },
  ReportDownload: {
    Path: "/ReportDownload/:SK/:TYPE",
    Name: "ReportDownload",
  },
  Survey: {
    Path: "/Survey/:SK",
    Name: "Survey",
  },
};
